import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';

import { Check } from '../../models/check';
import { CheckProvider } from '../../providers/check/check';
import { UserProvider } from '../../providers/user/user';
import { WorkplaceProvider } from '../../providers/workplace/workplace';


@IonicPage()
@Component({
  selector: 'page-check-info',
  templateUrl: 'check-info.html',
})
export class CheckInfoPage {

  check = {} as Check;
  delay;
  time;
  date;
  mode;
  title: string;
  users;
  workplaces;
  
  constructor(
    private loadingCtrl: LoadingController,
    public navCtrl: NavController, 
    public navParams: NavParams,
    public checkProvider: CheckProvider,
    public userProvider: UserProvider,
    public workplaceProvider: WorkplaceProvider,
  ) {

    this.mode = this.navParams.get('mode')
    this.initMode();

    this.users = this.userProvider.getUserNames();
    this.workplaces = this.workplaceProvider.getAllWorkplaces();
  }

  initMode() {
    var date;

    switch(this.mode) {
      case 'info': { 
        this.title = 'Información'; 
        this.check = this.navParams.get('check');

        this.delay = Number((this.check.delay / 1000 / 60).toFixed(2));

        date = new Date(this.check.timestamp)
        date.setMinutes(date.getMinutes() - (new Date().getTimezoneOffset()))
        this.date = date.toISOString();
        break
      };

      case 'edit': { 
        this.title = 'Editar'; 
        this.check = this.navParams.get('check');

        this.delay = Number((this.check.delay / 1000 / 60).toFixed(2));

        date = new Date(this.check.timestamp)
        date.setMinutes(date.getMinutes() - (new Date().getTimezoneOffset()))
        this.date = date.toISOString();
        break 
      };

      case 'add': { 
        this.title = 'Añadir'; 
        break
      };
    }
  }

  save() {
    this.userProvider.getNameOnce(this.check.userKey).subscribe(user => {
      this.check['userName'] = user.value;

      if(!this.delay) this.delay = 0;
      this.check.delay = Number((this.delay * 60 * 1000).toFixed(2));
      this.check.delayString = msToTime(this.check.delay);

      var date = new Date(this.date);
      date.setHours(this.time.split(':')[0])
      date.setMinutes(this.time.split(':')[1])

      this.check['timestamp'] = new Date(date).getTime();

      let loading = this.loadingCtrl.create()
      loading.present()

      this.checkProvider.save(this.check, this.check.userKey)
      .then(() => {
        loading.dismiss()
        this.navCtrl.pop();
      })
      .catch(error => {
        loading.dismiss()
        console.log(error)
      })
    })
  }
}

/**
 * Obtenir un string amb hores, minuts i segons a partir de uns milisegons donats.
 * 
 * @param ms Milisegons
 */
function msToTime(ms): string {
  var tipus;
  if(ms > 0) tipus = 'Retraso: ';
  else tipus = 'Pronto: '

  ms = Math.abs(ms);

  var h, m, s;
  s = Math.floor(ms / 1000);
  m = Math.floor(s / 60);
  s = s % 60;
  h = Math.floor(m / 60);
  m = m % 60;

  var result = s + ' seg';
  if(m > 0) result = m + ' min, ' + result;
  if(h > 0) result = h + ' h, ' + result;

  return tipus + result;
}


// WEBPACK FOOTER //
// ./src/pages/check-info/check-info.ts